import { createUseStyles } from 'react-jss';
import {
  backgroundSubtle01,
  heading02,
  iconPrimary,
  textSecondary,
} from '../../../theme';

export default createUseStyles(
  {
    root: {
      display: 'flex',
      alignItems: 'center',
      padding: [26, 40, 26, 0],
      backgroundColor: backgroundSubtle01,
      borderRadius: 4,
      position: 'relative',
      margin: [20, 0],
      ['@media (max-width: 768px)']: {
        padding: [24, 12, 24, 12],
        margin: [35, 0],
      },
    },

    rootDisabled: {
      opacity: 0.75,
      cursor: 'not-allowed',
    },

    icon: {
      width: 103,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      ['@media (max-width: 768px)']: {
        width: 25,
        padding: 10,
      },
    },

    badge: {
      marginLeft: 14,
      marginTop: -3,
    },

    body: {
      flexGrow: 1,
    },

    title: {
      display: 'flex',
      alignItems: 'center',
      ...heading02,
      ['@media (max-width: 768px)']: {
        fontSize: 14,
        paddingTop: '0.25rem',
      },
    },

    subtitle: {
      marginTop: 10,
      marginBottom: -2,
      color: textSecondary,
      ['@media (max-width: 768px)']: {
        marginTop: '0.25rem',
        marginBottom: '0.25rem',
      },
    },

    chevron: {
      flexGrow: 0,
      flexShrink: 0,
      width: 12,
      color: iconPrimary,
    },
  },
  {
    name: 'NavItem',
  },
);
